import { faCheck, faPencil } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton } from 'components'
import { ItemSignatureRecap, ItemVerificationDetails } from 'components/item-verification'
import { TripContext } from 'contexts'
import { ItemVerificationView } from 'enums'
import React, { FC, Fragment, useContext } from 'react'
import { useLicensePlateService, useNavigation, useOrderItemService, useParamService } from 'services'
import { VerifiedMethod } from 'services/enums'
import { LicensePlate, Order, OrderItem } from 'services/types'
import './item-details-page.scss'


export const ItemDetailsPage: FC = () => {

    const { getIntValue } = useParamService
    const { navigateTo } = useNavigation()
    const { verifyItem } = useOrderItemService()
    const { areAllLpItemsVerified } = useLicensePlateService()
    const tripContext = useContext(TripContext)
    const orderItemId: number | undefined = getIntValue('orderItemId')
    const searchType: ItemVerificationView | undefined = getIntValue('searchId')

    const orderItem: OrderItem = tripContext.orderItems.find(lp => lp.id === orderItemId) ?? {} as OrderItem
    const order: Order = tripContext.orders.find(lp => lp.id === orderItem.orderId) ?? {} as Order
    const licensePlates: LicensePlate[] = tripContext.licensePlates.filter(lp => lp.stopId === order.stopId) ?? []

    const handleVerifyItem = async () => {
        if (orderItem) {
            if (areAllLpItemsVerified(licensePlates, orderItem.lineItemId)) {
                await verifyItem(orderItem, VerifiedMethod.Manual)
            }
            if (searchType == ItemVerificationView.PoDetails) {
                await navigateTo(`verify-item?stopId=${order.stopId}&itemId=${orderItem.lineItemId}`, undefined, '/stop-overview')
            } else {
                await navigateTo(`verify-item?stopId=${order.stopId}&itemId=${orderItem.lineItemId}`, undefined, '/item-verification')
            }
        }
    }

    return (
        <Fragment>
            <ItemVerificationDetails orderItemId={orderItemId} />
            {order && order.signatureId &&
                <ItemSignatureRecap signatureId={order.signatureId} />
            }
            {order.signatureId == null &&
                <div className={'bottom-fix-action-row'}>
                    <ActionButton
                        icon={orderItem.verifiedMethod == null ? faCheck : faPencil}
                        buttonColor={orderItem.verifiedMethod == null ? '#EB5757' : '#F2994A'}
                        buttonText={orderItem.verifiedMethod == null ? 'Verify' : 'Edit'}
                        onClick={handleVerifyItem}
                    />
                </div>
            }
        </Fragment>
    )
}
